import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

const CTA = () => {
    return (
        <div className="bg-neutral-800 px-8 relative overflow-visible">
            <div className="max-w-5xl mx-auto relative z-50">
                <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg shadow-2xl p-8 translate-y-16 relative overflow-hidden">
                    <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-20 w-[300px] h-[300px] z-0">
                        <Logo width="100%" height="100%" logoFill="indigo" mobile={true} />
                    </div>
                    <div className="flex flex-col md:flex-row items-center gap-6 relative z-10">
                        <img src="/assets/Light.svg" alt="" className="w-12 h-12 flex-shrink-0" />
                        <div className="flex-1 text-center md:text-left pl-4">
                            <h3 className="!text-white !text-2xl lg:text-3xl font-bold font-['Montserrat'] mb-2">Never miss another customer</h3>
                            <p className="!text-white text-base font-medium font-['Inter']">Turn every answered call into a secured, committed booking.</p>
                        </div>
                        <div className="flex flex-col items-center md:items-end gap-2">
                            <Link to="/signup">
                                <div className="px-6 py-3 bg-white rounded hover:bg-gray-100 transition-colors cursor-pointer">
                                    <div className="text-blue-600 text-sm font-bold font-['Inter']">Join the Waitlist</div>
                                </div>
                            </Link>
                            <p className="!text-white text-xs font-medium font-['Inter']">Credit card required • Cancel anytime</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CTA;
